<template>
  <header class="yield-left-header">
    <div class="header-line left-line"></div>
    <div class="header-center">
      <h3>产量预测模型</h3>
      <p>最终产量预估 | 销售规划 | 存储策略 | 效益最大化</p>
    </div>
    <div class="header-line right-line"></div>
  </header>
</template>

<style lang="less" scoped>
.yield-left-header {
  height: 156px;
  flex-shrink: 0;
  position: relative;
  display: grid;
  grid-template-columns: 1fr 660px 1fr;
  align-items: start;
  color: #ffffff;
}

.header-center {
  position: relative;
  height: 100%;
  text-align: center;
}

.header-center::before {
  content: "";
  position: absolute;
  left: 0;
  right: 0;
  top: 6px;
  height: 88px;
  border-top: 2px solid rgba(53, 255, 235, 0.62);
  background: linear-gradient(90deg, transparent, rgba(0, 120, 110, 0.48), transparent);
  clip-path: polygon(0 0, 100% 0, 90% 100%, 10% 100%);
}

h3 {
  position: relative;
  z-index: 1;
  margin: 0;
  color: #ffffff;
  font-size: 42px;
  font-weight: 700;
  line-height: 106px;
  text-shadow:
    0 0 8px rgba(255, 255, 255, 0.4),
    0 0 16px rgba(45, 255, 232, 0.42);
}

p {
  position: relative;
  z-index: 1;
  margin: 4px 0 0;
  color: #ffffff;
  font-size: 30px;
  font-weight: 700;
  line-height: 28px;
}

.header-line {
  height: 38px;
  margin-top: 14px;
  position: relative;
  border-top: 1px solid rgba(46, 255, 232, 0.8);
}

.header-line::after {
  content: "";
  position: absolute;
  top: 8px;
  width: 250px;
  height: 11px;
  background: repeating-linear-gradient(
    110deg,
    rgba(34, 255, 232, 0.85) 0 8px,
    transparent 8px 15px
  );
  opacity: 0.78;
}

.left-line::after {
  right: 22px;
}

.right-line::after {
  left: 22px;
}
</style>
